import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "event-page-modal",
  templateUrl: "./event-page-modal.component.html",
  styleUrls: ["./event-page-modal.component.scss"],
})
export class EventPageModal implements OnInit {
  @ViewChild("content") public contentRef: TemplateRef<any>;
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  @Input("openModal") public openModal: Observable<any | false>;

  public modalText: string = "האם את.ה בטוח רוצה למחוק?";

  public modalHeader: string = "אישור מחיקה";
  public data: any = null;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}

  public open(content) {
    // @ts-ignore
    this.activeModal = this.modalService
      .open(content, {
        backdrop: true,
        backdropClass: "custom-event-backdropClass",
      })
      .result.then(
        (result) => {
          this.modalResult.emit(result === "delete" ? this.data : false);
        },
        (reason) => {
          this.modalResult.emit(false);
        }
      );
  }

  public ngOnInit(): void {
    this.openModal.subscribe((data) => {
      this.data = data;
      if (data) {
        this.open(this.contentRef);
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-modal/event-page-modal.component.ts